import { prettyDate, slotById } from "@/lib/studio";

export const BookingSummary = ({ iso, slot, space, submitting, onSubmit }) => (
  <section className="surface flex flex-col gap-6 border-[#FF3333]/30 p-6 md:flex-row md:items-center md:justify-between md:p-8" data-testid="booking-summary">
    <div className="font-tech text-sm text-zinc-300">
      <p data-testid="summary-date">{prettyDate(iso)}</p>
      <p data-testid="summary-slot" className="text-white">{slot ? slotById(slot).time : "No time selected"}</p>
      <p data-testid="summary-space" className="text-zinc-500">{space || "No space preference"}</p>
    </div>
    <button className="btn-riot" disabled={!slot || submitting} onClick={onSubmit} data-testid="booking-submit-btn">
      {submitting ? "Booking…" : "Confirm booking"}
    </button>
  </section>
);
